import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from 'react-query'

import { getTopUpDateDetails } from 'api/transactions'
import { useTopUpDateDetailsStore } from 'store/transactions'

import { DATASTATUS } from 'constants/status'

export const useTopUpDateDetails = () => {
  const { traderId } = useParams()
  const memberTraderId = parseInt(String(traderId) || '0')

  const TopUpDateDetailsModStatus = useTopUpDateDetailsStore(
    (state) => state.TopUpDateDetailsModStatus
  )
  const TopUpDateDetailsModStatusSet = useTopUpDateDetailsStore(
    (state) => state.TopUpDateDetailsModStatusSet
  )
  const TopUpDateDetailsModErrors = useTopUpDateDetailsStore(
    (state) => state.TopUpDateDetailsModErrors
  )
  const TopUpDateDetailsModErrorsSet = useTopUpDateDetailsStore(
    (state) => state.TopUpDateDetailsModErrorsSet
  )
  const TopUpDateDetails = useTopUpDateDetailsStore(
    (state) => state.TopUpDateDetails
  )
  const TopUpDateDetailsSet = useTopUpDateDetailsStore(
    (state) => state.TopUpDateDetailsSet
  )

  const queryClient = useQueryClient()
  const {
    data: dataTopUpDateDetails,
    isLoading: isLoadingTopUpDateDetails,
    isError: isErrorTopUpDateDetails,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useTopUpDateDetailsActivity'],
    queryFn: async () => {
      try {
        TopUpDateDetailsModStatusSet('loading')
        const response = await getTopUpDateDetails(
          memberTraderId
        )
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        TopUpDateDetailsModStatusSet('success')
        return response.data
      } catch (e) {
        TopUpDateDetailsModStatusSet('fail')
        TopUpDateDetailsModErrorsSet(JSON.stringify(e))
      }
    },
  })

  useEffect(() => {
    if (dataTopUpDateDetails) TopUpDateDetailsSet(dataTopUpDateDetails)
  }, [dataTopUpDateDetails, TopUpDateDetailsSet])

  return {
    memberTopUpDateDetails: TopUpDateDetails,
    memberTopUpDateDetailsModStatus: TopUpDateDetailsModStatus,
  }
}
